import { object, string } from 'yup';

const GRID_EXTERIOR_GAP_SIZE = '12px';

export const GRID_EXTERIOR_GAP = {
  exteriorGapXs: GRID_EXTERIOR_GAP_SIZE,
  exteriorGapS: GRID_EXTERIOR_GAP_SIZE,
  exteriorGapM: GRID_EXTERIOR_GAP_SIZE,
  exteriorGapL: GRID_EXTERIOR_GAP_SIZE,
  exteriorGapXl: GRID_EXTERIOR_GAP_SIZE
};

export const ERROR_MESSAGES = {
  name: 'Please enter a catalog type',
  salesOrg: 'Please select a sales organization'
};

export const errorMessage = 'Please enter a value.';

export const validationSchema = object().shape({
  name: string().required(errorMessage),
  salesOrg: string().required(errorMessage)
});
